export interface InteractionSummary {
  interactionId: string;
  status: SummaryStatus;
  summaryText?: string;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  errorMessage?: string;
}

export enum SummaryStatus {
  InProgress = "InProgress",
  Completed = "Completed",
  Failed = "Failed",
}

export interface GenerateSummaryResponse {
  interactionId: string;
  status: string;
}

export interface TranscribeAndSummarizeResponse {
  jobId: string;
  status: string;
}
